/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getNormativasClienteNoEnviadasPaginado, importacionMasivaDocumentos } from "../../../componentes/http/actions/DocumentoAction";
import { getClientesUsuario } from "../../../componentes/http/actions/UsuarioAction";
import {
  Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody,
  Typography, Box, Grid, TextField, FormControl, InputLabel, Select, MenuItem,
  TablePagination, useMediaQuery, useTheme, Card, CardContent, Button, CardActions,
  CircularProgress, Autocomplete, IconButton, Tooltip, Divider, InputAdornment, Stack, alpha,
  Checkbox, Chip, Alert, Dialog, DialogTitle, DialogContent, DialogActions,
} from "@mui/material";
import { jwtDecode } from "jwt-decode";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SearchIcon from "@mui/icons-material/Search";
import SendIcon from "@mui/icons-material/Send";
import ClearIcon from "@mui/icons-material/Clear";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DataLoaderCliente from "../../../componentes/data/DataLoaderCliente";
import DetalleNormativaClienteModal from "../../../componentes/modal/Normativa/DetalleNormativaClienteModal";
import { SemaforoBadge, EstadoChip } from "../../../componentes/navegacion/SemaforoBadge";
import LogoGRC from "../../../assets/Austranet-GRC_titulo.png";

const FILTERS_STORAGE_KEY = "integracionGRCNormativasFilters";

const saveFiltersToStorage = (filters) => {
  try { sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(filters)); }
  catch (error) { console.error("Error al guardar filtros:", error); }
};

const loadFiltersFromStorage = () => {
  try {
    const saved = sessionStorage.getItem(FILTERS_STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed.startDate) parsed.startDate = new Date(parsed.startDate);
      if (parsed.endDate) parsed.endDate = new Date(parsed.endDate);
      return parsed;
    }
  } catch (error) { console.error("Error al cargar filtros:", error); }
  return null;
};

const formatFecha = (value) =>
  value ? new Date(value).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) : "";

const IntegracionGRCNormativas = () => {
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const idUsuario = decoded["oid"];

  const savedFilters = loadFiltersFromStorage();

  const [serviciosDisponibles, setServiciosDisponibles] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [isLoadingNormativas, setIsLoadingNormativas] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [urlGrcFront, setUrlGrcFront] = useState(null);

  const [selectedNormativas, setSelectedNormativas] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [isSending, setIsSending] = useState(false);
  const [sendSuccess, setSendSuccess] = useState(false);
  const [sendError, setSendError] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const [openDetalleModal, setOpenDetalleModal] = useState(false);
  const [normativaSeleccionado, setNormativaSeleccionado] = useState(null);

  const [page, setPage] = useState(savedFilters?.page || 0);
  const [rowsPerPage, setRowsPerPage] = useState(savedFilters?.rowsPerPage || 10);

  const [searchTerm, setSearchTerm] = useState(savedFilters?.searchTerm || "");
  const [filterCliente, setFilterCliente] = useState(savedFilters?.filterCliente || "todos");
  const [startDate, setStartDate] = useState(savedFilters?.startDate || null);
  const [endDate, setEndDate] = useState(savedFilters?.endDate || null);

  const [clientes, setClientes] = useState([]);
  const [multipleClients, setMultipleClients] = useState(false);
  const [selectedClienteId, setSelectedClienteId] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const [loadedData, setLoadedData] = useState({
    organismos: [], tiposDocumento: [], estadosTramitacion: [], rubros: [],
    clasificaciones: [], clientes: [],
  });

  const [selectedFilters, setSelectedFilters] = useState(savedFilters?.selectedFilters || {
    organismo: null, tipoDocumento: null, estadoTramitacion: null, rubro: null,
  });

  const handleDataLoaded = useCallback((data) => {
    setLoadedData(data);
    if (savedFilters?.selectedFilters) {
      const restored = { ...savedFilters.selectedFilters };
      if (savedFilters.selectedFilters.organismo)
        restored.organismo = data.organismos.find((o) => o.id === savedFilters.selectedFilters.organismo.id) || null;
      if (savedFilters.selectedFilters.tipoDocumento)
        restored.tipoDocumento = data.tiposDocumento.find((t) => t.id === savedFilters.selectedFilters.tipoDocumento.id) || null;
      if (savedFilters.selectedFilters.estadoTramitacion)
        restored.estadoTramitacion = data.estadosTramitacion.find((e) => e.id === savedFilters.selectedFilters.estadoTramitacion.id) || null;
      if (savedFilters.selectedFilters.rubro)
        restored.rubro = data.rubros.find((r) => r.id === savedFilters.selectedFilters.rubro.id) || null;
      setSelectedFilters(restored);
    }
  }, []);

  useEffect(() => {
    const filtersToSave = { searchTerm, filterCliente, startDate, endDate, page, rowsPerPage, selectedFilters };
    saveFiltersToStorage(filtersToSave);
  }, [searchTerm, filterCliente, startDate, endDate, page, rowsPerPage, selectedFilters]);

  useEffect(() => { fetchClientes(); }, []);
  useEffect(() => { setMultipleClients(clientes && clientes.length > 1); }, [clientes]);

  useEffect(() => {
    if (clientes && clientes.length > 0 && !selectedClienteId) {
      setSelectedClienteId(clientes[0].id);
      if (clientes[0].urlGrcFront) setUrlGrcFront(clientes[0].urlGrcFront);
      const serviciosUnicos = clientes.reduce((servicios, cliente) => {
        if (cliente.servicios && Array.isArray(cliente.servicios)) {
          cliente.servicios.forEach((s) => { if (!servicios.includes(s)) servicios.push(s); });
        }
        return servicios;
      }, []);
      setServiciosDisponibles(serviciosUnicos);
    }
  }, [clientes, selectedClienteId]);

  useEffect(() => {
    if (selectedClienteId && clientes && clientes.length > 0) {
      const clienteSeleccionado = clientes.find((c) => c.id === selectedClienteId);
      if (clienteSeleccionado && clienteSeleccionado.urlGrcFront) {
        setUrlGrcFront(clienteSeleccionado.urlGrcFront);
      }
    }
  }, [selectedClienteId, clientes]);

  const fetchNormativasPaginadas = useCallback(() => {
    setIsLoadingNormativas(true);
    const filtros = {
      searchTerm,
      organismo: selectedFilters.organismo?.nombre || null,
      tipoDocumento: selectedFilters.tipoDocumento?.nombre || null,
      estadoTramitacion: selectedFilters.estadoTramitacion?.nombre || null,
      cliente: filterCliente !== "todos" ? filterCliente : null,
      rubro: selectedFilters.rubro?.nombre || null,
      fechaDesde: startDate, fechaHasta: endDate,
    };
    getNormativasClienteNoEnviadasPaginado(token, idUsuario, page + 1, rowsPerPage, filtros)
      .then((response) => {
        if (response?.items && Array.isArray(response.items)) {
          setDocumentos(response.items);
          setTotalCount(response.totalCount || 0);
        } else { setDocumentos([]); setTotalCount(0); }
      })
      .catch((error) => { console.error("Error al cargar normativas:", error); setDocumentos([]); setTotalCount(0); })
      .finally(() => { setIsLoadingNormativas(false); setInitialLoadComplete(true); });
  }, [page, rowsPerPage, searchTerm, filterCliente, selectedFilters, startDate, endDate, token, idUsuario]);

  useEffect(() => { fetchNormativasPaginadas(); }, [fetchNormativasPaginadas]);

  const handleFilterChange = (field, value) => { setSelectedFilters((p) => ({ ...p, [field]: value })); setPage(0); };

  const fetchClientes = () => {
    getClientesUsuario(token, idUsuario)
      .then((response) => setClientes(response && Array.isArray(response) ? response : []))
      .catch(() => setClientes([]));
  };

  const handleChangePage = (e, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); };

  const handleOpenDetalleModal = useCallback((n) => { setNormativaSeleccionado(n); setOpenDetalleModal(true); }, []);
  const handleCloseDetalleModal = useCallback(() => { setOpenDetalleModal(false); setNormativaSeleccionado(null); }, []);

  const handleSelectNormativa = (normativaId) => {
    setSelectedNormativas((prev) =>
      prev.includes(normativaId) ? prev.filter((id) => id !== normativaId) : [...prev, normativaId]
    );
  };

  const handleSelectAllOnPage = () => {
    const currentPageIds = documentos.map((doc) => doc.id);
    if (selectAll) {
      setSelectedNormativas((prev) => prev.filter((id) => !currentPageIds.includes(id)));
      setSelectAll(false);
    } else {
      setSelectedNormativas((prev) => {
        const newSelected = [...prev];
        currentPageIds.forEach((id) => { if (!newSelected.includes(id)) newSelected.push(id); });
        return newSelected;
      });
      setSelectAll(true);
    }
  };

  const handleClearSelection = () => { setSelectedNormativas([]); setSelectAll(false); };

  const enviarNormativasGRC = async (normativasIds, clienteId) => {
    const result = await importacionMasivaDocumentos(token, normativasIds, clienteId);
    return result;
  };

  const handleOpenConfirmDialog = () => {
    if (selectedNormativas.length === 0) { setSendError("Debe seleccionar al menos una normativa para enviar"); return; }
    if (!selectedClienteId) { setSendError("Debe seleccionar un cliente destino"); return; }
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => setOpenConfirmDialog(false);

  const handleSendToGRC = async () => {
    setOpenConfirmDialog(false);
    setIsSending(true);
    setSendError(null);
    setSendSuccess(false);
    if (!selectedClienteId) {
      setSendError("Debe seleccionar un cliente destino");
      setIsSending(false);
      return;
    }
    try {
      const result = await enviarNormativasGRC(selectedNormativas, selectedClienteId);
      if (result.success) {
        setSendSuccess(true);
        setSendError(null);
        setTimeout(() => {
          handleClearSelection();
          setSendSuccess(false);
          fetchNormativasPaginadas();
        }, 2000);
      } else {
        setSendError(result.message || "Error al enviar normativas");
        setSendSuccess(false);
      }
    } catch (error) {
      setSendError(error || "Error al enviar normativas");
      setSendSuccess(false);
    } finally {
      setIsSending(false);
    }
  };

  const handleSearchTermChange = (e) => { setSearchTerm(e.target.value); setPage(0); };
  const handleClienteFilterChange = (e) => { setFilterCliente(e.target.value); setPage(0); };
  const handleStartDateChange = (v) => { setStartDate(v); setPage(0); };
  const handleEndDateChange = (v) => { setEndDate(v); setPage(0); };

  const handleResetFilters = () => {
    setStartDate(null); setEndDate(null); setSearchTerm(""); setFilterCliente("todos");
    setSelectedFilters({ organismo: null, tipoDocumento: null, estadoTramitacion: null, rubro: null });
    setPage(0);
    sessionStorage.removeItem(FILTERS_STORAGE_KEY);
  };

  const isSelected = (id) => selectedNormativas.includes(id);

  const selectedCountOnPage = useMemo(() => {
    const currentPageIds = documentos.map((doc) => doc.id);
    return selectedNormativas.filter((id) => currentPageIds.includes(id)).length;
  }, [selectedNormativas, documentos]);

  const renderNoDataMessage = () => (
    <Paper sx={{ p: 5, textAlign: "center" }}>
      <Typography variant="subtitle1" sx={{ mb: 0.5 }}>Sin resultados</Typography>
      <Typography variant="body2" color="text.secondary">
        No se encontraron normativas pendientes de envío con los filtros actuales. Ajusta la búsqueda o límpiala para ver todo.
      </Typography>
      <Button onClick={handleResetFilters} sx={{ mt: 2 }} variant="outlined" size="small">
        Limpiar filtros
      </Button>
    </Paper>
  );

  const tableColumns = useMemo(() => {
    const cols = [
      {
        id: "select",
        label: (
          <Checkbox
            checked={selectAll && selectedCountOnPage === documentos.length && documentos.length > 0}
            indeterminate={selectedCountOnPage > 0 && selectedCountOnPage < documentos.length}
            onChange={handleSelectAllOnPage}
          />
        ),
        minWidth: 50, align: "center",
      },
      { id: "nombre", label: "Nombre", minWidth: 220, maxWidth: 320 },
      { id: "organismoEmisor", label: "Organismo", minWidth: 120, hideOnBreakpoint: "md" },
      { id: "tipoDocumento", label: "Tipo", minWidth: 120, hideOnBreakpoint: "md" },
      { id: "estadoTramitacion", label: "Estado", minWidth: 130, format: (v) => <EstadoChip estado={v} /> },
      { id: "fechaPublicacion", label: "Publicación", minWidth: 110, format: formatFecha },
    ];
    if (multipleClients) {
      cols.push({
        id: "clientes", label: "Clientes", minWidth: 150, hideOnBreakpoint: "md",
        format: (v) => (v && Array.isArray(v) ? v.map((c) => c.nombre).join(", ") : ""),
      });
    }
    if (serviciosDisponibles.includes("Compromisos")) {
      cols.push({
        id: "compromisos", label: "Compromisos", minWidth: 110, align: "center", hideOnBreakpoint: "md",
        format: (v, doc) => <SemaforoBadge cantidad={v && Array.isArray(v) ? v.length : 0} documento={doc} tipo="Compromisos" />,
      });
    }
    if (serviciosDisponibles.includes("Obligaciones")) {
      cols.push({
        id: "obligaciones", label: "Obligaciones", minWidth: 110, align: "center", hideOnBreakpoint: "md",
        format: (v, doc) => <SemaforoBadge cantidad={v && Array.isArray(v) ? v.length : 0} documento={doc} tipo="Obligaciones" />,
      });
    }
    cols.push({ id: "acciones", label: "Acciones", minWidth: 110, align: "right" });
    return cols;
  }, [multipleClients, serviciosDisponibles, selectAll, selectedCountOnPage, documentos.length]);

  const visibleColumns = useMemo(
    () => tableColumns.filter((c) => !(c.hideOnBreakpoint === "md" && isSmall)),
    [tableColumns, isSmall]
  );

  const renderMobileCard = (documento) => (
    <Card
      key={documento.id}
      elevation={1}
      sx={{
        mb: 1.5,
        border: isSelected(documento.id) ? `2px solid ${theme.palette.primary.main}` : "1px solid transparent",
        backgroundColor: isSelected(documento.id) ? alpha(theme.palette.primary.main, 0.06) : "inherit",
      }}
    >
      <CardContent sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: 1 }}>
          <Checkbox
            sx={{ p: 0.5, mt: -0.5 }}
            checked={isSelected(documento.id)}
            onChange={() => handleSelectNormativa(documento.id)}
          />
          <Typography variant="subtitle2" sx={{ wordBreak: "break-word", flex: 1 }}>{documento.nombre}</Typography>
          <EstadoChip estado={documento.estadoTramitacion} />
        </Box>
        <Divider sx={{ my: 1 }} />
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Organismo</Typography>
            <Typography variant="body2">{documento.organismoEmisor}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Tipo</Typography>
            <Typography variant="body2">{documento.tipoDocumento}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Publicación</Typography>
            <Typography variant="body2">{formatFecha(documento.fechaPublicacion)}</Typography>
          </Grid>
          {serviciosDisponibles.includes("Compromisos") && (
            <Grid item xs={6}>
              <Typography variant="caption" color="text.secondary">Compromisos</Typography>
              <Box><SemaforoBadge cantidad={documento.compromisos?.length || 0} documento={documento} tipo="Compromisos" /></Box>
            </Grid>
          )}
          {serviciosDisponibles.includes("Obligaciones") && (
            <Grid item xs={6}>
              <Typography variant="caption" color="text.secondary">Obligaciones</Typography>
              <Box><SemaforoBadge cantidad={documento.obligaciones?.length || 0} documento={documento} tipo="Obligaciones" /></Box>
            </Grid>
          )}
          {multipleClients && (
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">Clientes</Typography>
              <Typography variant="body2">
                {documento.clientes && Array.isArray(documento.clientes) ? documento.clientes.map((c) => c.nombre).join(", ") : ""}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
      <CardActions sx={{ px: 2, pb: 2, flexWrap: "wrap", gap: 1 }}>
        <Button variant="contained" size="small" onClick={() => handleOpenDetalleModal(documento)} startIcon={<VisibilityOutlinedIcon />}>
          Detalle
        </Button>
        {documento.url && (
          <Button variant="outlined" size="small" component="a" href={documento.url} target="_blank" rel="noopener noreferrer" startIcon={<DescriptionOutlinedIcon />}>
            Documento
          </Button>
        )}
      </CardActions>
    </Card>
  );

  return (
    <Box sx={{ pt: { xs: 2.5, sm: 1.5 }, pb: 4 }}>
      <DataLoaderCliente onDataLoaded={handleDataLoaded} />

      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2 }}>
          <Box>
            <Typography variant="h5">Enviar normativas a AustranetGRC</Typography>
            <Typography variant="body2" color="text.secondary">
              Selecciona las normativas pendientes y envíalas al sistema GRC del cliente.
            </Typography>
          </Box>
          {urlGrcFront && (
            <Button
              variant="outlined" color="primary"
              endIcon={<Box component="img" src={LogoGRC} alt="GRC Logo" sx={{ height: 20, width: "auto" }} />}
              onClick={() => window.open(`${urlGrcFront}/documentos/paginador`, "_blank")}
              sx={{ textTransform: "none", whiteSpace: "nowrap" }}
            >
              Ir a
            </Button>
          )}
        </Box>

        {sendSuccess && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {selectedNormativas.length} normativa(s) enviadas exitosamente a la aplicación GRC.
          </Alert>
        )}
        {sendError && (
          <Alert severity="error" sx={{ mt: 2 }} onClose={() => setSendError(null)}>
            {sendError}
          </Alert>
        )}
      </Box>

      {/* Filtros */}
      <Paper elevation={1} sx={{ p: { xs: 2, sm: 2.5 }, mb: 3 }}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, textTransform: "uppercase", letterSpacing: "0.04em", fontSize: "0.72rem" }}>
          Filtros de búsqueda
        </Typography>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <TextField
              fullWidth label="Buscar por nombre o código" value={searchTerm} onChange={handleSearchTermChange}
              InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon fontSize="small" color="disabled" /></InputAdornment>) }}
            />
          </Grid>
          {multipleClients && (
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth>
                <InputLabel>Cliente</InputLabel>
                <Select value={filterCliente} onChange={handleClienteFilterChange} label="Cliente">
                  <MenuItem value="todos">Todos</MenuItem>
                  {clientes.map((c) => (<MenuItem key={c.id} value={c.nombre}>{c.nombre}</MenuItem>))}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete options={loadedData.organismos || []} getOptionLabel={(o) => o.nombre || ""}
              renderInput={(p) => <TextField {...p} label="Organismo emisor" />}
              value={selectedFilters.organismo} onChange={(e, v) => handleFilterChange("organismo", v)}
              isOptionEqualToValue={(o, v) => o.id === v?.id} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete options={loadedData.tiposDocumento || []} getOptionLabel={(o) => o.nombre || ""}
              renderInput={(p) => <TextField {...p} label="Tipo de documento" />}
              value={selectedFilters.tipoDocumento} onChange={(e, v) => handleFilterChange("tipoDocumento", v)}
              isOptionEqualToValue={(o, v) => o.id === v?.id} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete options={loadedData.estadosTramitacion || []} getOptionLabel={(o) => o.nombre || ""}
              renderInput={(p) => <TextField {...p} label="Estado de tramitación" />}
              value={selectedFilters.estadoTramitacion} onChange={(e, v) => handleFilterChange("estadoTramitacion", v)}
              isOptionEqualToValue={(o, v) => o.id === v?.id} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete options={loadedData.rubros || []} getOptionLabel={(o) => o.nombre || ""}
              renderInput={(p) => <TextField {...p} label="Rubro" />}
              value={selectedFilters.rubro} onChange={(e, v) => handleFilterChange("rubro", v)}
              isOptionEqualToValue={(o, v) => o.id === v?.id} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker sx={{ width: "100%" }} format="dd/MM/yyyy" label="Fecha desde"
                value={startDate} onChange={handleStartDateChange} slotProps={{ textField: { size: "small" } }} />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker sx={{ width: "100%" }} format="dd/MM/yyyy" label="Fecha hasta"
                value={endDate} onChange={handleEndDateChange} slotProps={{ textField: { size: "small" } }} />
            </LocalizationProvider>
          </Grid>
        </Grid>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ mt: 2.5 }} alignItems={{ xs: "stretch", sm: "center" }}>
          <Button variant="outlined" onClick={handleResetFilters}>Limpiar filtros</Button>
          {multipleClients && (
            <FormControl size="small" sx={{ minWidth: 220 }}>
              <InputLabel>Cliente destino</InputLabel>
              <Select value={selectedClienteId || ""} onChange={(e) => setSelectedClienteId(e.target.value)} label="Cliente destino" required>
                {clientes.map((c) => (<MenuItem key={c.id} value={c.id}>{c.nombre}</MenuItem>))}
              </Select>
            </FormControl>
          )}
          <Box sx={{ flexGrow: 1 }} />
          <Button
            variant="contained" color="primary" onClick={handleOpenConfirmDialog}
            startIcon={isSending ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
            disabled={isSending || selectedNormativas.length === 0}
          >
            {isSending ? "Enviando..." : `Enviar a AustranetGRC (${selectedNormativas.length})`}
          </Button>
        </Stack>
      </Paper>

      {/* Chip de selección */}
      {selectedNormativas.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Chip label={`${selectedNormativas.length} seleccionadas`} color="primary" onDelete={handleClearSelection} deleteIcon={<ClearIcon />} />
        </Box>
      )}

      {/* Resultados */}
      {(!initialLoadComplete || isLoadingNormativas) ? (
        <Box display="flex" justifyContent="center" p={5}><CircularProgress /></Box>
      ) : documentos && documentos.length > 0 ? (
        <>
          {isMobile ? (
            <Box>{documentos.map(renderMobileCard)}</Box>
          ) : (
            <TableContainer component={Paper} elevation={1} sx={{ overflow: "auto" }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {visibleColumns.map((column) => (
                      <TableCell key={column.id} align={column.align || "left"} sx={{ minWidth: column.minWidth, py: 1.25, px: 2, whiteSpace: "nowrap" }}>
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {documentos.map((documento) => {
                    const selected = isSelected(documento.id);
                    return (
                      <TableRow
                        key={documento.id} hover selected={selected}
                        onClick={() => handleSelectNormativa(documento.id)}
                        sx={{
                          cursor: "pointer",
                          "&.Mui-selected": { backgroundColor: (t) => alpha(t.palette.primary.main, 0.08) },
                          "&.Mui-selected:hover": { backgroundColor: (t) => alpha(t.palette.primary.main, 0.12) },
                          "&:hover": { backgroundColor: (t) => alpha(t.palette.primary.main, 0.04) },
                        }}
                      >
                        {visibleColumns.map((column) => {
                          if (column.id === "select") {
                            return (
                              <TableCell key={column.id} align="center" padding="checkbox">
                                <Checkbox
                                  checked={selected}
                                  onChange={() => handleSelectNormativa(documento.id)}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </TableCell>
                            );
                          }
                          if (column.id === "acciones") {
                            return (
                              <TableCell key={column.id} align="right" sx={{ px: 1.5 }}>
                                <Stack direction="row" spacing={0.25} justifyContent="flex-end">
                                  <Tooltip title="Ver detalle">
                                    <IconButton size="small" color="primary"
                                      onClick={(e) => { e.stopPropagation(); handleOpenDetalleModal(documento); }}>
                                      <VisibilityOutlinedIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                  {documento.url && (
                                    <Tooltip title="Ver documento">
                                      <IconButton size="small" color="primary" component="a"
                                        href={documento.url} target="_blank" rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()}>
                                        <DescriptionOutlinedIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Stack>
                              </TableCell>
                            );
                          }
                          const value = documento[column.id];
                          return (
                            <TableCell
                              key={column.id} align={column.align || "left"}
                              sx={{
                                py: 1.25, px: 2,
                                maxWidth: column.id === "nombre" ? 320 : 160,
                                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                                fontWeight: column.id === "nombre" ? 600 : 400,
                              }}
                            >
                              {column.format ? column.format(value, documento) : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]} component="div" count={totalCount}
            rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Filas por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          />
        </>
      ) : (
        renderNoDataMessage()
      )}

      {/* Dialog de confirmación */}
      <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
        <DialogTitle>Confirmar envío a GRC</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            ¿Está seguro que desea enviar {selectedNormativas.length} normativa(s) a la aplicación GRC?
          </Typography>
          {multipleClients && selectedClienteId && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Cliente destino: <strong>{clientes.find((c) => c.id === selectedClienteId)?.nombre}</strong>
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Esta acción creará los documentos en el sistema de AustranetGRC.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="inherit">Cancelar</Button>
          <Button onClick={handleSendToGRC} color="primary" variant="contained" autoFocus disabled={!selectedClienteId}>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {openDetalleModal && (
        <DetalleNormativaClienteModal open={openDetalleModal} onClose={handleCloseDetalleModal}
          normativa={normativaSeleccionado} isLoading={isLoadingNormativas} />
      )}
    </Box>
  );
};

export default IntegracionGRCNormativas;